import { render, staticRenderFns } from "./PedidosLiberacoes.vue?vue&type=template&id=662b32e6&scoped=true&"
import script from "./PedidosLiberacoes.vue?vue&type=script&lang=js&"
export * from "./PedidosLiberacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662b32e6",
  null
  
)

export default component.exports